import React from 'react'
import { Users } from 'lucide-react'
import GenericTabelaPage from '../../components/tabelas/GenericTabelaPage'
import { familiasApi } from '../../api/tabelasBasicas'

const FamiliasPage: React.FC = () => (
  <GenericTabelaPage
    titulo="Famílias de Produtos"
    breadcrumb="Tabelas › Básicas"
    icon={<Users size={17} />}
    cdMaxLen={4}
    nmMaxLen={100}
    api={familiasApi}
  />
)

export default FamiliasPage
